import styled from "styled-components";
import colors from "../../constants/colors";

export const InputWrapper = styled("div")({
  position: "relative",
  width: "100%",
  marginBottom: "0.375rem",
});

export const FloatingLabel = styled("label")<{
  $hasValue?: boolean;
  $focused?: boolean;
  $error?: boolean;
  $disabled?: boolean;
}>(({ $hasValue, $focused, $error, $disabled }) => ({
  position: "absolute",
  right: "0.75rem",
  top: $hasValue || $focused ? "0.375rem" : "50%",
  transform: $hasValue || $focused ? "translateY(0)" : "translateY(-50%)",
  fontSize: $hasValue || $focused ? "0.6875rem" : "0.875rem",
  color: $disabled
    ? colors.GREY_4
    : $error
      ? colors.ORANGE
      : $focused
        ? colors.PURPLE
        : colors.GREY_6,
  transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
  pointerEvents: $hasValue || $focused ? "none" : "auto",
  fontWeight: $hasValue || $focused ? 600 : 400,
  backgroundColor: colors.BACKGROUND,
  padding: $hasValue || $focused ? "0 0.25rem" : "0",
  zIndex: 1,
  cursor: $hasValue || $focused ? "default" : "text",
}));

export const Input = styled("input")<{
  $hasValue?: boolean;
  $error?: boolean;
}>(({ $hasValue, $error }) => ({
  padding: "1.125rem 2.5rem 0.375rem 0.75rem",
  border: `1.5px solid ${$error ? colors.ORANGE : colors.GREY_3}`,
  borderRadius: "8px",
  fontSize: "0.875rem",
  textAlign: "right",
  width: "100%",
  boxSizing: "border-box",
  backgroundColor: colors.WHITE,
  transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
  outline: "none",
  minHeight: "44px",

  "&::placeholder": {
    color: "transparent",
  },

  "&:focus": {
    borderColor: $error ? colors.ORANGE : colors.PURPLE,
    boxShadow: $error
      ? `0px 0px 0px 3px rgba(255, 165, 0, 0.1)`
      : `0px 0px 0px 3px ${colors.PURPLE_LIGHTER}`,
  },

  "&:disabled": {
    backgroundColor: colors.GREY_2,
    cursor: "not-allowed",
    color: colors.GREY_5,
  },
}));

export const IconWrapper = styled("div")({
  position: "absolute",
  left: "0.75rem",
  bottom: "25%",
  transform: "translateY(-50%)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 2,
});

export const SuccessIcon = styled("div")({
  color: colors.GREEN,
  display: "flex",
  alignItems: "center",
  fontSize: "1.25rem",
});

export const ErrorIcon = styled("div")({
  color: colors.ORANGE,
  display: "flex",
  alignItems: "center",
  fontSize: "1.25rem",
});

export const ErrorText = styled("div")({
  fontSize: "0.875rem",
  color: colors.ORANGE,
  marginTop: "0.25rem",
  fontWeight: 500,
  textAlign: "right",
  direction: "rtl",
  unicodeBidi: "embed",
});

export const Counter = styled("span")<{
  $isMaxReached: boolean;
}>(({ $isMaxReached }) => ({
  color: $isMaxReached ? colors.ORANGE : colors.GREY_5,
  fontSize: "0.75rem",
  position: "absolute",
  bottom: "0.75rem",
  left: "1rem",
  pointerEvents: "none",
  fontWeight: 500,
}));
